import { FC } from 'react'

import { Format, FormatOptions } from 'services/Dates'
import { DateInputFormat, MerinioDateFormat } from 'services/types/dates'
import { t } from 'translations'

type TimeZoneConditionalOptions =
  | {
      isUTC: boolean
      timeZone: string
    }
  | {
      isUTC?: never
      timeZone?: never
    }

type RangeProps = {
  date: Date[] | string[]
  outFormat?: keyof MerinioDateFormat //needs to have all formats from getFormat function
  inFormat?: keyof DateInputFormat
  isExtraShift?: boolean
  noParantheses?: boolean
  range: true
  options?: { locale?: Locale }
} & TimeZoneConditionalOptions

type WithoutRange = {
  date: Date | string
  outFormat?: keyof MerinioDateFormat //needs to have all formats from getFormat function
  inFormat?: keyof DateInputFormat
  isExtraShift?: boolean
  noParantheses?: boolean
  range?: false
  options?: { locale?: Locale }
} & TimeZoneConditionalOptions

const DateTime: FC<WithoutRange | RangeProps> = ({
  date,
  outFormat = 'dateTime',
  inFormat,
  isExtraShift,
  noParantheses,
  range,
  isUTC,
  options = {},
  timeZone
}) => {
  const allOptions = { ...options, outFormat, inFormat, isUTC, timeZone } as FormatOptions

  // Return a date range
  if (range) {
    const end = isExtraShift ? '' : ` - ${Format(date[1], allOptions)}`
    const startParenthese = noParantheses ? '' : '('
    const endParenthese = noParantheses ? '' : ')'

    // Returns all day, if the date are both the same day
    if (Format(date[0], allOptions) === '00:00' && Format(date[1], allOptions) === '23:59') return <>{`${startParenthese}${t('ALL_DAY')}${endParenthese}`}</>
    return <>{`${startParenthese}${Format(date[0], allOptions)}${end}${endParenthese}`}</>
  }

  return <>{Format(date, allOptions)}</>
}

export default DateTime
